// PATCH: Responsive spacing and stacking for mobile/tablet

import { Grid, Box } from '@mui/material';

const SplitSection = ({
  leftContent,
  rightContent,
  leftProps = {},
  rightProps = {},
  containerProps = {},
  sx = {},
  expandedContent = null
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        px: { xs: 0, sm: 1, md: 2 }, // PATCH: extra space on desktop only
        ...sx
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 5 }} // PATCH: more compact on mobile
        alignItems='flex-start'
        {...containerProps}
      >
        {/* Left Section */}
        <Grid
          item
          xs={12}
          md={6}
          {...leftProps}
          sx={{
            mb: { xs: 2, md: 0 }, // PATCH: add space below for stacking on mobile
            ...leftProps.sx
          }}
        >
          {leftContent}
        </Grid>

        {/* Right Section */}
        <Grid
          item
          xs={12}
          md={6}
          {...rightProps}
          sx={{
            mb: { xs: 2, md: 0 },
            ...rightProps.sx
          }}
        >
          {rightContent}
        </Grid>

        {/* Full width expanded content - if provided */}
        {expandedContent && (
          <Grid item xs={12}>
            {expandedContent}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default SplitSection;
